import React from 'react';

const Blog = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.20919 3.33397C5.20919 2.06801 6.23545 1.04175 7.50141 1.04175H16.6703C17.9362 1.04175 18.9625 2.06801 18.9625 3.33397V15.0035C18.9625 16.7298 17.5631 18.1292 15.8367 18.1292H3.75665L3.74805 18.1292C2.25192 18.1292 1.03906 16.9164 1.03906 15.4202V8.33519C1.03906 7.98993 1.31895 7.71004 1.66421 7.71004H5.20919V3.33397ZM3.7505 16.8789H3.75458C4.55719 16.8754 5.20673 16.2237 5.20673 15.4202V8.96034H2.28936V15.4202C2.28936 16.2258 2.94244 16.8789 3.74805 16.8789L3.7505 16.8789V16.8789ZM15.8367 16.8789H6.03119C6.30075 16.4578 6.45704 15.9573 6.45704 15.4202V10.0022H6.45949V3.33397C6.45949 2.75853 6.92597 2.29205 7.50141 2.29205H16.6703C17.2457 2.29205 17.7122 2.75853 17.7122 3.33397V15.0035C17.7122 16.0392 16.8725 16.8789 15.8367 16.8789ZM8.33492 11.8778H15.8367V10.6275H8.33492V11.8778ZM15.8367 14.795H8.33492V13.5447H15.8367V14.795ZM9.58522 7.50183V5.41799H14.5864V7.50183H9.58522ZM8.33492 5.00122C8.33492 4.54087 8.7081 4.16769 9.16845 4.16769H15.0032C15.4635 4.16769 15.8367 4.54087 15.8367 5.00122V7.91859C15.8367 8.37894 15.4635 8.75213 15.0032 8.75213H9.16845C8.7081 8.75213 8.33492 8.37894 8.33492 7.91859V5.00122Z",
      fill: "white"
    }
  )
);

export { Blog };
//# sourceMappingURL=Blog.js.map
